var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.reportBug}},[_vm._t("default",[_vm._v(_vm._s(_vm.$t('labels.reportbug')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }